import React, { useEffect, useState } from 'react';
import { IVendaDireta } from '../../../../../../../../../interfaces/IBaseDeCalculo';
import styles from './operacaoVendaLista.module.scss';
import InformacaoBasica from '../../../../../../../../../components/informacaoBasica/informacaoBasica';
import { BrButton } from '@govbr-ds/react-components';
import NCMViewContainerList from '../baseDeCalculoFormItemNCM/components/ncmViewContainerList/ncmViewContainerList';
import { useQuery } from '@tanstack/react-query';
import { useBackEndRequests } from '../../../../../../../lib/backEndRequests';
import { Button, Modal } from 'react-dsgov';
import { formatarCNPJOrCpf } from '../../../../../../../../../utils/formatCNPJOrCPF';
import CustomConfirmer from '../../../../../../../../../components/customConfirmer/customConfirmer';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';
import { ETipoOperacaoVendaDireta } from 'enums/ETipoOperacaoVendaDireta';

interface ITitularArrendatarioOperacaoVendaListaProps {
  vendasDiretas: IVendaDireta[];
  setVendasDiretas: React.Dispatch<React.SetStateAction<IVendaDireta[]>>;
  setVendaDiretaEdicao: React.Dispatch<React.SetStateAction<IVendaDireta | undefined>>;
  vendaDiretaEdicao: IVendaDireta | undefined;
  vendaDiretaCadastro: IVendaDireta | undefined;
  headers: Array<{ field: string; label: string; classe?: string }>;
}

const OperacaoVendaLista: React.FC<ITitularArrendatarioOperacaoVendaListaProps> = ({
  vendasDiretas,
  headers,
  setVendasDiretas,
  setVendaDiretaEdicao,
  vendaDiretaCadastro,
  vendaDiretaEdicao,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [idVendaDiretaADeletar, setIdVendaDiretaADeletar] = useState<number>();
  const [exclusaoConfirmada, setExclusaoConfirmada] = useState(false);
  const { deleteVendaDiretaPLG } = useBackEndRequests();

  const { data: deleteVendaDiretaData } = useQuery<string, IErrorWithSentryId>({
    queryKey: ['deleteVendaDiretaPLG', idVendaDiretaADeletar],
    queryFn: async () => {
      await deleteVendaDiretaPLG(idVendaDiretaADeletar!);
      return 'Venda Direta excluída com sucesso';
    },
    enabled: !!idVendaDiretaADeletar && exclusaoConfirmada,
  });

  useEffect(() => {
    if (deleteVendaDiretaData) {
      setExclusaoConfirmada(false);
      setIdVendaDiretaADeletar(undefined);
      setVendasDiretas((vendasDiretas) =>
        vendasDiretas.filter((vendaDireta) => vendaDireta.id !== idVendaDiretaADeletar)
      );
    }
  }, [deleteVendaDiretaData]);

  const abrirFecharModal = () => {
    setOpenModal(!openModal);
  };

  const confirmarExclusao = async () => {
    setExclusaoConfirmada(true);
    abrirFecharModal();
  };

  const excluirVendaDireta = (idVendaDireta: number) => {
    abrirFecharModal();
    setIdVendaDiretaADeletar(idVendaDireta);
  };

  const editarVendaDireta = (vendaDireta: IVendaDireta) => {
    setVendaDiretaEdicao(vendaDireta);
  };

  return vendasDiretas.length > 0 ? (
    <div className={styles.containerVendaDireta}>
      {vendasDiretas.map(
        (vendaDireta, index) =>
          vendaDireta.id !== vendaDiretaEdicao?.id &&
          vendaDireta.id !== vendaDiretaCadastro?.id && (
            <div key={index} className={styles.containerBaseDeCalculo}>
              <div key={index} className={styles.containerDadosBasicos}>
                {headers.map((header, index) => (
                  <InformacaoBasica
                    key={index}
                    aria-label={`${header.label}: ${(vendaDireta as any)[header.field]}`}
                    titulo={header.label}
                    conteudo={(() => {
                      if (header.field.includes('tipoOperacao')) {
                        return (vendaDireta as any)[header.field]
                          ? ETipoOperacaoVendaDireta[
                              (vendaDireta as any)[header.field] as keyof typeof ETipoOperacaoVendaDireta
                            ]
                          : '-';
                      }
                      if (header.field.includes('cpfCnpj')) {
                        return (vendaDireta as any)[header.field]
                          ? formatarCNPJOrCpf((vendaDireta as any)[header.field])
                          : '-';
                      }
                      return (vendaDireta as any)[header.field];
                    })()}
                  />
                ))}
              </div>
              {
                <NCMViewContainerList
                  idVendaDireta={vendaDireta.id}
                  refreshQuery={true}
                  setRefreshQuery={() => {}}
                  hideAction={true}
                />
              }
              <div className={styles.botoes}>
                <BrButton
                  secondary
                  circle
                  onClick={() => editarVendaDireta(vendaDireta)}
                  aria-label='Editar'
                  title='Editar'
                >
                  <i className={`fas fa-edit fa-md  ${styles.columnIcon}`} />
                </BrButton>
                <BrButton
                  secondary
                  circle
                  onClick={() => excluirVendaDireta(vendaDireta.id || 0)}
                  aria-label='Excluir'
                  title='Excluir'
                >
                  <i className={`fas fa-trash-alt fa-md  ${styles.columnIcon}`} />
                </BrButton>
                <Modal title='Excluir Venda Direta PLG' useScrim modalOpened={openModal}>
                  <Modal.Body>Deseja excluir a Venda Direta selecionada?</Modal.Body>
                  <Modal.Footer justify-content='end'>
                    <Button secondary small m={2} onClick={abrirFecharModal}>
                      Cancelar
                    </Button>
                    <CustomConfirmer asyncCall={() => confirmarExclusao()}>Confirmar</CustomConfirmer>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          )
      )}
    </div>
  ) : null;
};

export default OperacaoVendaLista;
